import type { MantineStyleProp, PaperProps } from '@mantine/core';
import type { ReactNode } from 'react';
import { Paper } from '@mantine/core';

interface AuthCardProps {
  children: ReactNode;
  w?: PaperProps['w'];
  p?: PaperProps['p'];
  px?: PaperProps['px'];
  py?: PaperProps['py'];
  style?: MantineStyleProp;
}

export const AuthCard = ({
  children,
  w = { base: '100%', md: 440 },
  p,
  px,
  py,
  style
}: AuthCardProps) => (
  <Paper radius="lg" withBorder shadow="none" w={w} p={p} px={px} py={py} style={style}>
    {children}
  </Paper>
);
